import { t } from '../../../i18n/strings.js';

// Emojis em caixas do mesmo tamanho → peso visual equilibrado.
const ITEMS = [
  ['💪', 'benefit1'],
  ['🎥', 'benefit2'],
  ['📊', 'benefit4'],
  ['🧘', 'benefit6'],
  ['🚀', 'benefit5'],
];

export default function BenefitsSection() {
  return (
    <section>
      <h2 className="font-display font-extrabold text-[28px] leading-tight text-center">
        {t('paywallIntl.benefitsTitle')} <span className="text-cyan">FitClutch</span>
      </h2>
      <div className="grid grid-cols-1 gap-2 mt-4">
        {ITEMS.map(([emoji, key]) => (
          <div key={key} className="flex items-center gap-3 rounded-2xl bg-surface px-3.5 py-3 border border-white/5">
            <div
              className="w-10 h-10 shrink-0 rounded-xl bg-cyan/15 flex items-center justify-center text-[22px] leading-none"
              aria-hidden="true"
            >
              {emoji}
            </div>
            <span className="text-[15px] leading-snug">{t(`paywallIntl.${key}`)}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
